import { render, staticRenderFns } from "./InformationItem.vue?vue&type=template&id=97c83e76&scoped=true&"
import script from "./InformationItem.vue?vue&type=script&lang=js&"
export * from "./InformationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c83e76",
  null
  
)

export default component.exports